module.exports = __webpack_public_path__ + "static/media/slightLeft.bf21336b.svg";